<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- G100系共通部品_Steps -->
    <app-j200-steps></app-j200-steps>

    <!-- メッセージ -->
    <div class="message">
      <!-- メッセージ本文 -->
      <div class="message-text">
        <div class="p-d-flex p-jc-center">
          <i class="pi pi-check-circle" style="font-size: 6rem"></i><br />
        </div>
        <div class="message-margin"></div>
        <div class="p-d-flex p-jc-center">事例紹介記事を登録・更新しました。</div>
      </div>
    </div>

    <!-- ボタンエリア -->
    <div class="p-d-flex p-jc-center button-area">
      <button
        pButton
        type="button"
        label="事例紹介記事管理へ戻る"
        class="button-default-size button1"
        (click)="moveJ201()"
      ></button>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
